module.exports = __webpack_public_path__ + "static/img/12.9144a80.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/12.png
// module id = 53qu
// module chunks = 0